import type { GamePreviewMode } from "./gamePreviewConstants";

const RELOAD_PARAM = "_previewReload";

/** ลบพารามิเตอร์ reload ชั่วคราวออกจาก URL เกม */
export function stripPreviewReloadParam(gameUrl: string): string {
    const trimmed = gameUrl.trim();
    if (!trimmed) return "";

    try {
        const url = new URL(trimmed);
        url.searchParams.delete(RELOAD_PARAM);
        return url.toString();
    } catch {
        return trimmed;
    }
}

/**
 * URL สำหรับ iframe — ใส่ token ตอนสลับ desktop/mobile เพื่อโหลดเกมใหม่ทั้งหน้า
 * (เกมอาจ cache layout เดิมถ้าแค่ resize iframe)
 */
export function buildGamePreviewSrc(
    gameUrl: string,
    mode: GamePreviewMode,
    reloadToken: number
): string {
    const base = stripPreviewReloadParam(gameUrl);
    if (!base) return "";

    try {
        const url = new URL(base);
        url.searchParams.set(RELOAD_PARAM, `${mode}-${reloadToken}`);
        return url.toString();
    } catch {
        return base;
    }
}
